import { Convenio } from '../../../interfaces/convenio';

export function convenioNaLista(convenios: Convenio[], cdConvenio: number | string | null): boolean {
  return cdConvenio != null && convenios.some(c => Number(c.cdConvenio) === Number(cdConvenio));
}
